<template>
  <!-- <div class="al-nav">
    <span @click="setPage('database')">Priority Samples</span>
    <span @click="setPage('train')">Model Training</span> -->
  <!-- <span @click="setPage('ssl')">Self Supervised Learning</span> -->
  <!-- </div> -->
  <div>
    <!-- <ActiveLearningDatabaseViewer v-if="page === 'database'" @navigate="(site, sxId, dt) => emitNavigate(site, sxId, dt)"/> -->
    <!-- <ResourceDashboard v-if="page === 'train'"/> -->
    <ResourceDashboard @navigate="(site, sxId, dt) => emitNavigate(site, sxId, dt)" />
    <!-- <SelfSupervisedLearning v-if="page === 'ssl'"/> -->
  </div>
</template>

<script>
// import ActiveLearningDatabaseViewer from './ActiveLearningDatabaseViewer.vue'
// import ModelTraining from './ModelTraining.vue'
import ResourceDashboard from './ModellingComponents/ResourceDashboard.vue'
// import SelfSupervisedLearning from './SelfSupervisedLearning.vue'


export default {
  name: 'ActiveLearning',
  emits: ['navigate'],
  components: {
    // ActiveLearningDatabaseViewer,
    ResourceDashboard,
    // SelfSupervisedLearning,
  },
  data() {
    return {
      page: 'database',
    }
  },
  methods: {
    emitNavigate(site, sxId, dt) {
      this.$emit('navigate', site, sxId, dt);
    },
    // setPage(page) {
    //   this.page = page;
    // },
  },
}
</script>

<style scoped>
.al-nav {
  display: flex;
  height: 37px;
  gap: 3px;
  padding: 0px 0;
  background-color: rgb(35, 45, 58);
}

.al-nav span {
  font-size: 1.2em;
  font-weight: bold;
  cursor: pointer;
  padding: 3px 8px;
  color: var(--colour-bg-light);
}

.al-nav span:hover {
  background-color: rgb(55, 68, 85);
}
</style>
